module.exports = __webpack_public_path__ + "static/media/icon-insurance-app.305bdd6b.svg";